<template>
	<div class="planWrapper">
<!-- 		<h1 class="heading">Розрахунок сальдо</h1>
		<p>запускаємо літачок простіше</p>
		<div class="underscore"></div> -->
		<div class="container">
	<h1 class="heading">Розрахунок сальдо</h1>
	<p>з вибором виду рахунка</p>
  <div class="underscore"></div>

</div>
  <div class="saldo">Забудьте про літачки на папірцях. Оберіть вид рахунка та запустіть веб-літачок</div>
    <div id="app">
      <div class="button-block">
        <button class="button-block__button" v-on:click="typeChecked = 'active'" v-bind:class="{ enabled : typeChecked == 'active' }">
        Активний
        </button>
        <button v-bind:class="{ enabled : typeChecked == 'passive' }" class="button-block__button" v-on:click="typeChecked = 'passive'">
        Пасивний
        </button>
      </div>
      <div class="table" style="margin-bottom: 10px;">
        <div class="table__column" v-bind:class="{ hidden : typeChecked !== 'active' }">
          <p style="text-align: center; border-top: 1px solid #EEC03A;padding-top: 3px; border-bottom: 1px solid #EEC03A; padding-bottom: 3px; margin-top: 15px; margin-bottom: 0px; font-size: 16px;">S' по Дт: <input class="begin" type="number" v-model.value="sActive"></p>
          
        </div>
        <div class="table__column" v-bind:class="{ hidden : typeChecked !== 'passive' }">
          <p style="text-align: center; border-top: 1px solid #EEC03A;padding-top: 3px; border-bottom: 1px solid #EEC03A; padding-bottom: 3px; margin-top: 15px; margin-bottom: 0px; font-size: 16px;">S' по Кт: <input class="begin" type="number" v-model.value="sPassive"></p>
        </div>
      </div>

      <div class="table">
        <div class="table__column">
          <input class="input" v-for="(item, index) in active" type="number" v-model.value="item.num">
          <button class="add_row" v-on:click="active.push({'num': '0'})">+ Додати рядок</button>
        </div>
        
        <div class="table__column" >
          <input class="input" v-for="(item, index) in passive" type="number" v-model.value="item.num">
          <button class="add_row" v-on:click="passive.push({'num': '0'})">+ Додати рядок</button>
        </div>  
      </div>
      <div class="table">
        <div class="table__column" style="text-align: center; border-top: 1px solid #EEC03A;padding-top: 3px; border-bottom: 1px solid #EEC03A; padding-bottom: 3px; font-size: 16px;">
          Оборот по Дт: <!-- <input class="table__column" type="text" v-model.value="obActive"> -->
          <div class="turnover">{{ _.sumBy(active, function(o) { return parseFloat(o.num) }) }} </div>
        </div>
        <div class="table__column" style="text-align: center; border-top: 1px solid #EEC03A;padding-top: 3px; border-bottom: 1px solid #EEC03A; padding-bottom: 3px; font-size: 16px;">
          Оборот по Кт:
          <!-- <input class="table__column" type="text" v-model.value="obPassive"> -->
          <div class="turnover">{{ _.sumBy(passive, function(o) { return parseFloat(o.num) }) }} </div>
        </div>
      </div>
    <!--  <button v-on:click="sum">0</button>
      <input type="text" v-model="JSON.stringify(active) + ' | ' + JSON.stringify(passive)"> -->
      <div class="table">
        <div class="table__column" v-bind:class="{ hidden : typeChecked !== 'active' } ">
          <p style="text-align: center; border-bottom: 1px solid #EEC03A; padding-top: 3px; padding-bottom: 3px; margin: 0px; font-size: 16px;">
            S'' по Дт: <br> <span class="end">{{ parseFloat(sActive) + _.sumBy(active, function(o) { return parseFloat(o.num) }) - _.sumBy(passive, function(o) { return parseFloat(o.num) }) }} </span>
          </p>
        </div>
        <div class="table__column" v-bind:class="{ hidden : typeChecked !== 'passive' } ">
          <p style="text-align: center; border-bottom: 1px solid #EEC03A; padding-top: 3px; padding-bottom: 3px; margin: 0px; font-size: 16px;">
            S'' по Кт: <br> <span style="font-size: 12px; font-weight: lighter;">{{ parseFloat(sPassive) - _.sumBy(active, function(o) { return parseFloat(o.num) }) + _.sumBy(passive, function(o) { return parseFloat(o.num) }) }} </span>
          </p>
        </div>
      </div>
    </div>
	</div>
</template>
<script>
	
export default {
	data () {
		return {
			typeChecked: 'active',
		    sActive: '0',
		    sPassive: '0',
		    active: [
		      { 'num': 0 }
		    ],
		    passive: [
		      { 'num': 0 }
		    ],
		    obActive: 0,
		    obPassive: 0,
		    sfActive: 0,
		    sfPassive: 0
				}
			},
			mounted: function() {
			},
	methods: {
sum: function() {
        activel = this.active
        this.obActive = _.sumBy(activel, function(o) { return parseFloat(o.num) });
        passivel = this.passive
        this.obPassive = _.sumBy(passivel, function(o) { return parseFloat(o.num) });
      }
		}
	}

</script>
<style scoped>
	.planWrapper {
		background-color: white;
/*		position: absolute;
		top: 0;
		min-height: 100%;
		left: 0;
		right: 0; */
	}
	h1 + p {
		font-size: 16px;
		color: grey;
		text-align: center;
		margin-top: -10px;
	}
	    a:link {
    color: grey;
    }
    a:hover {
    color: #2382DA;
    }
    ul {
    color: #000000; /* Цвет маркеров */
   }
	body {
		overflow-x: hidden;
	}
	.container {
		width: 90vw;
		margin: 0px auto;
	}

    .heading {
    text-align: center;
    font-size:  26px;
    margin-top: 25px;
    margin-bottom: 15px;
    font-weight: bold;
    }

    h1 + p {
      text-align: center;
      color: grey;
      font-size: 12px;
      margin-top: -10px;
    }

        h2 + p {
      text-align: center;
      color: grey;
      font-size: 10px;
      margin-top: -10px;
    }

	.class {
		font-size: 18px;
	}
	.synt {
		font-size: 16px;
	}
	.accordion {
  background-color: #eee;
  color: #444;
  cursor: pointer;
  padding: 15px 10px;
  width: 100%;
  border: none;
  text-align: left;
  outline: none;
  font-size: 14px;
  transition: 0.4s;
  border-radius: 10px;
  margin-top: 5px;
}

.active, .accordion:hover {
  background-color: #d7e0df; 
 color: #2382DA;
}

.panel {
  padding: 0 18px;
  display: none;
  background-color: white;
  overflow: hidden;
}
.panel p {
	padding: 5px 0 10px;
	font-size: 14px;
	border-bottom: solid 1px #eee;
}
  .underscore {
  height: 4px;
  width: 50px;
  background-color: #EEC03A;
  margin: auto;
  margin-top: 10px;
  margin-bottom: 30px;
  border-radius: 2px;
}
.button {
  width: 130px;
  background-color: #fdf8e3;
  margin: auto;
  text-align: center;
  border-radius: 5px;
  color: #d69c86;
  padding: 10px 5px;
  margin-top: 10px;
  margin-bottom: 10px;
  text-decoration: none;
  transition: 0.4s;
  overflow: hidden;
}

      .button-block {
        margin: auto;
        text-align: center;
        width: 80vw;
        display: block;
      }
      .button-block__button {
        display: inline;
        background: #FFFFFF;
        border: 2px solid #EEC03A;
        padding: 5px;
        border-radius: 5px;
        width: 130px;
        /* margin-top: 10px; */
        color: #EEC03A;
        outline: none;
        margin-top: 2px;
        cursor: pointer;
        font-size: 16px;
      }
      .table {
        display: -webkit-flex;
        display: -moz-flex;
        display: -ms-flex;
        display: -o-flex;
        display: flex;
        -webkit-flex-direction: row;
        -moz-flex-direction: row;
        -ms-flex-direction: row;
        -o-flex-direction: row;
        flex-direction: row;
        width: 90vw;
        margin: auto;
      }
      .table__column {
        -webkit-flex-direction: column;
        -moz-flex-direction: column;
        -ms-flex-direction: column;
        -o-flex-direction: column;
        flex-direction: column;
        display: flex;
        width: 50%;
        font-size: 14px;
        transition: all 0.3s ease-in-out;
      }
      .hidden {
        opacity: 0.2;
      }
      .enabled {
  width: 130px;
  background-color: #EEC03A;
  margin: auto;
  text-align: center;
  border-radius: 5px;
  color: #FFFFFF;
  padding: 5px;
  /* margin-top: 10px; */
  text-decoration: none;
  transition: 0.4s;
  border: none;
  overflow: hidden;
  outline: none;
  border: 2px solid #EEC03A;
  margin-top: 2px;
  cursor: pointer;
      }

.input {
  font-weight: lighter;
  padding: 5px;
  margin-top: 3px; 
  margin-right: 2px;
  margin-left: 2px;
  border: 1px solid #BBC5C3;
  /*width: 60%*/
}

.add_row {
  width: 130px;
  background-color: #EEEEEE;
  margin: auto;
  text-align: center;
  border-radius: 5px;
  color: #676A6C;
  padding: 5px;
  margin-top: 10px;
  margin-bottom: 10px;
  text-decoration: none;
  transition: 0.4s;
  border: none;
  overflow: hidden;
  outline: none;
  cursor: pointer;
  /* border: 2px solid #EEC03A; */
}

.begin {
  padding: 5px;
  font-weight: lighter;
  margin-top: 5px;
  margin-bottom: 5px;
  font-size: 12px;
  width: 40%;
  border: 1px solid #BBC5C3;
}

.end {
  font-weight: lighter;
  font-size: 12px;
}

.turnover {
  font-weight: lighter;
  font-size: 12px;
  border: 0;
  margin-top: 3px;
}

.underscore_saldo {
  height: 2px;
  width: 98%;
  background-color: #EEC03A;
  margin: auto;
/*   margin-top: 10px;
margin-bottom: 30px; */
  border-radius: 2px;
}

.saldo {
  text-align: center;
  font-weight: lighter;
  font-size: 14px;
  padding: 10px;
} 
</style>


// WEBPACK FOOTER //
// src/Plan.vue